import { FunctionComponent } from 'react';
import { spacingHelper, mediaHelper } from '@property.com.au/ui-kit';
import { PageContainer } from '../../../components/PageContainer/PageContainer';
import styled from 'styled-components';
import { AdvertisementBrickWithData } from '../AdvertismentBrick/AdvertisementBrickWithData';
import { MediaShowcaseBrickWithData } from '../MediaShowcaseBrick/MediaShowcaseBrickWithData';
import { CarouselPropertyCollectionBricksWithData } from '../CarouselPropertyCollectionsBricks/CarouselPropertyCollectionsBricksWithData';
import { NeighbouringPropertiesWithData } from '../NeighbouringPropertiesWithData/NeighbouringPropertiesWithData';
import { NearbyChildcareCentresBrickWithData } from '../NearbyChildcareCentresBrick/NearbyChildcareCentresBrickWithData';
import { MarketInsightsBrickWithData } from '../MarketInsightsBrick/MarketInsightsBrick';
import { NearbySchoolsBricksWithData } from '../NearbySchoolsBricks/NearbySchoolsBricksWithData';
import { PropertyMapBrickWithData } from '../PropertyMapBrick/PropertyMapBrickWithData';
import { PropertyDescriptionBrickWithData } from '../PropertyDescriptionBrick/PropertyDescriptionBrickWithData';
import { PropertyTimelineEventsWithData } from '../PropertyTimelineEvents/PropertyTimelineEvents';
import { PropertyFeaturesBrickWithData } from '../PropertyFeaturesBrick/PropertyFeaturesBrick';
import { InternetAvailabilityBrickWithData } from '../InternetAvailabilityBrick/InternetAvailabilityBrick';
import { NearbyPlanningPermitsBrickWithData } from '../NearbyPlanningPermitsBrick/NearbyPlanningPermitsBrick';
import { MarketTrendsBrickWithData } from '../MarketTrendsBrick/MarketTrendsBrick';
import { InternetAvailabilityBrickWithDataV2 } from '../InternetAvailabilityBrickV2/InternetAvailabilityBrickV2';
import { PropertyValuationBrickWithDataV2 } from '../PropertyValuationBrick/PropertyValuationBrickWithDataV2';
import { GovernmentOverlaysBrickWithData } from '../GovernmentOverlaysBrick/GovernmentOverlaysBrickWithData';

const PropertyPageMainBodyContentContainer = styled(PageContainer)`
  flex-grow: 1;
  padding: ${spacingHelper('medium')} ${spacingHelper('extraSmall')} ${spacingHelper('large')};

  > :not(:last-child) {
    margin-bottom: ${spacingHelper('large')};
  }

  ${mediaHelper('desktopMin')} {
    padding: ${spacingHelper('medium')} 0 ${spacingHelper('large')};
  }
`;

export const PropertyPageMainContent: FunctionComponent = () => {
  return (
    <PropertyPageMainBodyContentContainer>
      <MediaShowcaseBrickWithData />
      <PropertyValuationBrickWithDataV2 />
      <PropertyDescriptionBrickWithData />
      <PropertyTimelineEventsWithData />
      <PropertyMapBrickWithData />
      <AdvertisementBrickWithData />
      <PropertyFeaturesBrickWithData />
      <GovernmentOverlaysBrickWithData />
      <InternetAvailabilityBrickWithData />
      <InternetAvailabilityBrickWithDataV2 />
      <NearbyPlanningPermitsBrickWithData />
      <MarketTrendsBrickWithData />
      <MarketInsightsBrickWithData />
      <NearbySchoolsBricksWithData />
      <NearbyChildcareCentresBrickWithData />
      <CarouselPropertyCollectionBricksWithData />
      <NeighbouringPropertiesWithData />
    </PropertyPageMainBodyContentContainer>
  );
};
